// 管理后台登录态 + 权限（localStorage 存储）

export function setAuth({ token, username, nickname, is_super, permissions }) {
  if (token) localStorage.setItem('admin_token', token)
  localStorage.setItem('admin_username', nickname || username || '管理员')
  localStorage.setItem('admin_is_super', is_super ? '1' : '0')
  localStorage.setItem('admin_permissions', JSON.stringify(permissions || []))
}

// 仅刷新权限（/me 拉回时用），不动 token
export function setPerms({ nickname, username, is_super, permissions }) {
  if (nickname || username) localStorage.setItem('admin_username', nickname || username)
  localStorage.setItem('admin_is_super', is_super ? '1' : '0')
  localStorage.setItem('admin_permissions', JSON.stringify(permissions || []))
}

export function clearAuth() {
  localStorage.removeItem('admin_token')
  localStorage.removeItem('admin_username')
  localStorage.removeItem('admin_is_super')
  localStorage.removeItem('admin_permissions')
}

export function isSuper() {
  return localStorage.getItem('admin_is_super') === '1'
}

export function getPerms() {
  try {
    return JSON.parse(localStorage.getItem('admin_permissions') || '[]')
  } catch {
    return []
  }
}

// 是否拥有某功能权限（超管恒 true）
export function hasPerm(key) {
  if (!key) return true
  return isSuper() || getPerms().includes(key)
}
